import React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import Header from '../../commons/Header';
import {
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../styled-components';
import SearchInput from '../../commons/SearchInput';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import Footer from '../../commons/Footer';
import RecurrentContractsTable from './RecurrentContractsTable';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import BurgerMenu from '../../commons/BurgerMenu';

const RecurrentEnergyPresentational = ({
  data,
  profile,
  query,
  total,
  onFilter,
  userType = '',
  totPod = 0,
  totPdr = 0,
}) => {
  const [t] = useTranslation('CONTRACTS');
  const { offset, limit, customerType } = query;
  const [mappedData, setMappedData] = useState(data);

  useEffect(() => {
    const mapData = data.map((recurringFee) => {
      return {
        ...recurringFee,
        extraShare: recurringFee.extraShare - recurringFee.adminShare,
      };
    });
    setMappedData(mapData);
  }, [data]);

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:RECURRENT_CONTRACTS')}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />

          <Row className="align-items-center">
            <Col className="">
              <ContFlexRight>
                Contratti POD:&nbsp;<strong>{totPod}</strong>&nbsp; | Contratti
                PDR:&nbsp;<strong>{totPdr}</strong>
              </ContFlexRight>
            </Col>
          </Row>

          <Row className="search-add-cont m-t-20">
            {!(profile && profile._id) && (
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.admin }}
                  onFilter={({ search }) => onFilter({ admin: search })}
                  label={t('SEARCH:ADMINISTRATOR')}
                />
              </Col>
            )}
            {profile.type !== 'UTILIZER' && (
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.customer }}
                  onFilter={({ search }) => onFilter({ customer: search })}
                  label={t('SEARCH:CUSTOMER')}
                />
              </Col>
            )}
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.pod_pdr }}
                onFilter={({ search }) => onFilter({ pod_pdr: search })}
                label={t('SEARCH:POD_PDR')}
              />
            </Col>
            {profile.type !== 'UTILIZER' && (
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.condo_vat_cf }}
                  onFilter={({ search }) => onFilter({ condo_vat_cf: search })}
                  label={t('SEARCH:CLIENT_VAT_CODE')}
                />
              </Col>
            )}
            {profile.type !== 'UTILIZER' && (
              <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear className="no-width">
                  <Row>
                    <Col xs="6">
                      <Label>Tipo cliente</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="customerType"
                          name="customerType"
                          value={customerType}
                          onChange={({ target: { value: customerType } }) =>
                            onFilter({ customerType })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="condos">Condomini</option>
                          <option value="customerExtra">Clienti privati</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            )}
          </Row>
        </section>

        <section className="m-t-20">
          <RecurrentContractsTable
            data={mappedData}
            total={total}
            profileType={profile.type}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            userType={userType}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default RecurrentEnergyPresentational;
